import { enableUIV2 } from 'helper/configuration';

export const REVIEW_SCREEN = {
  SUBMIT_BUTTON: 'bookingReview.submitButton',
  SUBMIT_BUTTON_PLURAL: 'bookingReview.submitButtonPlural',
  EDIT_BUTTON: 'bookingReview.editButton',
  GOOD_TO_GO: 'bookingReview.goodToGo',
  WARNING_TEXT: 'bookingReview.warningText',
  CHANGE_ADDRESS: 'bookingReview.changeAddress',
};

export const QUICK_VIEW = {
  NOT_READY_YET: 'bookingReview.quickView.notReadyYet',
  READY_TO_GO: 'bookingReview.quickView.readyToGo',
  REVIEW_ORDER: 'bookingReview.quickView.reviewOrder',
  REVIEW_ORDER_PLURAL: 'bookingReview.quickView.reviewOrderPlural',
};

export const TABLE_COLUMN = {
  ADDRESS_DETAIL_BULK_BOOKING_PAGE: 'history.table.receiverDetails',
  ADDRESS_DETAIL_BULK_UPLOAD: 'bookingReview.tableColumn.detail',
  FEE: 'bookingReview.tableColumn.fee',
  NO: 'bookingReview.tableColumn.no',
  SERVICE_TYPE: 'bookingReview.tableColumn.serviceType',
  STATUS: 'bookingReview.tableColumn.status',
  ORIGINAL_INPUT: 'bookingReview.addressEntered',
  BULK_SENDER_DETAILS: 'bookingReview.tableColumn.senderDetail',
  BULK_RECIPIENT_DETAILS: 'bookingReview.tableColumn.recipientDetail',
};

export const TABLE_COLUMN_V2 = {
  NO: { key: 'NO', value: 'bookingReview.tableColumnV2.no' },
  REF: { key: 'REF', value: 'bookingReview.tableColumnV2.ref' },
  SENDER_DETAILS: {
    key: 'SENDER_DETAILS',
    value: 'bookingReview.tableColumnV2.senderDetail',
  },
  RECIPIENT_DETAILS: {
    key: 'RECIPIENT_DETAILS',
    value: 'bookingReview.tableColumnV2.recipientDetail',
  },
  SERVICE_TYPE: {
    key: 'SERVICE_TYPE',
    value: 'bookingReview.tableColumnV2.serviceType',
  },
  CASH_ON_DELIVERY: {
    key: 'CASH_ON_DELIVERY',
    value: 'bookingReview.tableColumnV2.cashOnDelivery',
  },
  WEIGHT: { key: 'WEIGHT', value: 'bookingReview.tableColumnV2.weight' },
  PAYMENT: { key: 'PAYMENT', value: 'bookingReview.tableColumnV2.fee' },
  STATUS: { key: 'STATUS', value: 'bookingReview.tableColumnV2.status' },
};

export const TABLE_COLUMN_V2_MUST_SHOW = [
  TABLE_COLUMN_V2.RECIPIENT_DETAILS.key,
  TABLE_COLUMN_V2.PAYMENT.key,
  TABLE_COLUMN_V2.STATUS.key,
];

export const MAX_TEXT_LENGTH = 120;
export const BULK_UPLOAD_LIMIT = 150; // TO-DO: discuss the limit
export const BULK_CREATE_SIZE = 8;

/*
 * [key]: field identifier. also used to identify review error type
 * [orderAttribute]: attribute name of the field in review order object
 * [dataType]: data type of the field value, e.g. string, number, boolean etc
 * [editable]: indicate whether the field is editable in review table
 * [visibleInReviewTableColumn]: whether the field data is displayed in review table column
 * [inItinerary]: whether the field is part of itinerary object
 * [updateSenderInItineray]: whether when updating this field for a drop-off stop in MSD order,
 * it should be updated in pick-up stop in same MSD order too
*/
export const REVIEW_ORDER_FIELDS = {
  BATCH_REF: {
    key: 'BATCH_REF',
    orderAttribute: 'batchReference',
    dataType: 'string',
    editable: false,
    visibleInReviewTableColumn: true,
    inItinerary: false,
  },
  CASH_ON_DELIVERY: {
    key: 'CASH_ON_DELIVERY',
    orderAttribute: 'itemAmount',
    dataType: 'number',
    editable: true,
    visibleInReviewTableColumn: true,
    inItinerary: true,
  },
  PARCEL_CATEGORY: {
    key: 'PARCEL_CATEGORY',
    orderAttribute: 'parcelCategory',
    dataType: 'string',
    editable: false,
    visibleInReviewTableColumn: false,
    inItinerary: true,
  },
  PROMO: {
    key: 'PROMO',
    orderAttribute: 'promo',
    dataType: 'string',
    editable: false,
    visibleInReviewTableColumn: false,
    inItinerary: false,
  },
  VEHICLE_TYPE: {
    key: 'VEHICLE_TYPE',
    orderAttribute: 'vehicleType',
    dataType: 'string',
    editable: false,
    visibleInReviewTableColumn: false,
    inItinerary: false,
  },
  WEIGHT: {
    key: 'WEIGHT',
    orderAttribute: 'weight',
    dataType: 'number',
    editable: true,
    visibleInReviewTableColumn: true,
    inItinerary: true,
  },
  SEQUENCE_NUMBER: {
    key: 'SEQUENCE_NUMBER',
    orderAttribute: 'sequenceNumber',
    dataType: 'number',
    editable: false,
    visibleInReviewTableColumn: true,
    inItinerary: false,
  },
  REFERENCE_CODE: {
    key: 'REFERENCE_CODE',
    orderAttribute: 'referenceCode',
    dataType: 'string',
    editable: false,
    visibleInReviewTableColumn: false,
    inItinerary: false,
  },
  SENDER_NAME: {
    key: 'SENDER_NAME',
    orderAttribute: 'name',
    dataType: 'string',
    editable: true,
    visibleInReviewTableColumn: true,
    inItinerary: true,
    updateSenderInItineray: true,
  },
  SENDER_PHONE: {
    key: 'SENDER_PHONE',
    orderAttribute: 'phone',
    dataType: 'string',
    editable: true,
    visibleInReviewTableColumn: true,
    inItinerary: true,
    updateSenderInItineray: true,
  },
  SENDER_ADDRESS: {
    key: 'SENDER_ADDRESS',
    orderAttribute: 'origin',
    dataType: 'string',
    editable: true,
    visibleInReviewTableColumn: true,
    inItinerary: true,
    updateSenderInItineray: true,
  },
  SENDER_INSTRUCTION: {
    key: 'SENDER_INSTRUCTION',
    orderAttribute: 'instruction',
    dataType: 'string',
    editable: false, // TODO: Make visible & editable
    visibleInReviewTableColumn: false,
    inItinerary: true,
    updateSenderInItineray: true,
  },
  RECEIVER_NAME: {
    key: 'RECEIVER_NAME',
    orderAttribute: 'name',
    dataType: 'string',
    editable: true,
    visibleInReviewTableColumn: true,
    inItinerary: true,
  },
  RECEIVER_PHONE: {
    key: 'RECEIVER_PHONE',
    orderAttribute: 'phone',
    dataType: 'string',
    editable: true,
    visibleInReviewTableColumn: true,
    inItinerary: true,
  },
  RECEIVER_ADDRESS: {
    key: 'RECEIVER_ADDRESS',
    orderAttribute: 'destination',
    dataType: 'string',
    editable: true,
    visibleInReviewTableColumn: true,
    inItinerary: true,
  },
  RECEIVER_INSTRUCTION: {
    key: 'RECEIVER_INSTRUCTION',
    orderAttribute: 'instruction',
    dataType: 'string',
    editable: false, // TODO: Make visible & editable
    visibleInReviewTableColumn: false,
    inItinerary: true,
  },
  SERVICE_TYPE: {
    key: 'SERVICE_TYPE',
    orderAttribute: 'serviceType',
    dataType: 'string',
    editable: false,
    visibleInReviewTableColumn: true,
    inItinerary: false,
  },
  PAYMENT: {
    key: 'PAYMENT',
    orderAttribute: 'paymentMethod',
    dataType: 'string',
    editable: false,
    visibleInReviewTableColumn: true,
    inItinerary: false,
  },
  PARTNER_ORDER_ID: {
    key: 'PARTNER_ORDER_ID',
    orderAttribute: 'partnerOrderID',
    dataType: 'string',
    editable: false,
    visibleInReviewTableColumn: false,
    inItinerary: false,
  },
};

// [isSkipQuoteError: true] errors that would affect getting a valid quote
// when such error exist should skip fetching quote
export const EXCEL_ERRORS = {
  invalid_sender_name: {
    message: 'v2.error.uploadOrder.validationError.invalid_sender_name',
    type: REVIEW_ORDER_FIELDS.SENDER_NAME.key,
  },
  different_sender_name: {
    message: 'v2.error.uploadOrder.validationError.different_sender_name',
    type: REVIEW_ORDER_FIELDS.SENDER_NAME.key,
    isSkipQuoteError: true,
  },
  sender_name_too_long: {
    message: 'v2.error.uploadOrder.validationError.input_too_long',
    type: REVIEW_ORDER_FIELDS.SENDER_NAME.key,
  },
  invalid_sender_phone: {
    message: 'v2.error.uploadOrder.validationError.invalid_phone_format',
    type: REVIEW_ORDER_FIELDS.SENDER_PHONE.key,
  },
  different_sender_phone: {
    message: 'v2.error.uploadOrder.validationError.different_sender_phone',
    type: REVIEW_ORDER_FIELDS.SENDER_PHONE.key,
    isSkipQuoteError: true,
  },
  sender_phone_too_long: {
    message: 'v2.error.uploadOrder.validationError.input_too_long',
    type: REVIEW_ORDER_FIELDS.SENDER_PHONE.key,
  },
  invalid_sender_address: {
    message: 'v2.error.uploadOrder.validationError.invalid_address',
    type: REVIEW_ORDER_FIELDS.SENDER_ADDRESS.key,
    isSkipQuoteError: true,
  },
  empty_sender_address: {
    message: enableUIV2()
      ? 'v2.error.uploadOrder.validationError.empty_field'
      : 'v2.error.uploadOrder.validationError.empty_sender_address',
    type: REVIEW_ORDER_FIELDS.SENDER_ADDRESS.key,
    isSkipQuoteError: true,
  },
  different_sender_address: {
    message: 'v2.error.uploadOrder.validationError.different_sender_address',
    type: REVIEW_ORDER_FIELDS.SENDER_ADDRESS.key,
    isSkipQuoteError: true,
  },
  sender_location_details_too_long: {
    message:
      'v2.error.uploadOrder.validationError.sender_location_details_too_long',
    type: REVIEW_ORDER_FIELDS.SENDER_INSTRUCTION.key,
  },
  invalid_recipient_phone: {
    message: 'v2.error.uploadOrder.validationError.invalid_phone_format',
    type: REVIEW_ORDER_FIELDS.RECEIVER_PHONE.key,
  },
  recipient_phone_too_long: {
    message: 'v2.error.uploadOrder.validationError.input_too_long',
    type: REVIEW_ORDER_FIELDS.RECEIVER_PHONE.key,
  },
  invalid_recipient_name: {
    message: 'v2.error.uploadOrder.validationError.invalid_recipient_name',
    type: REVIEW_ORDER_FIELDS.RECEIVER_NAME.key,
  },
  recipient_name_too_long: {
    message: 'v2.error.uploadOrder.validationError.input_too_long',
    type: REVIEW_ORDER_FIELDS.RECEIVER_NAME.key,
  },
  invalid_recipient_address: {
    message: 'v2.error.uploadOrder.validationError.invalid_address',
    type: REVIEW_ORDER_FIELDS.RECEIVER_ADDRESS.key,
    isSkipQuoteError: true,
  },
  empty_recipient_address: {
    message: enableUIV2()
      ? 'v2.error.uploadOrder.validationError.empty_field'
      : 'v2.error.uploadOrder.validationError.empty_recipient_address',
    type: REVIEW_ORDER_FIELDS.RECEIVER_ADDRESS.key,
    isSkipQuoteError: true,
  },
  recipient_location_details_too_long: {
    message:
      'v2.error.uploadOrder.validationError.recipient_location_details_too_long',
    type: REVIEW_ORDER_FIELDS.RECEIVER_INSTRUCTION.key,
  },
  item_note_too_long: {
    message: 'v2.error.uploadOrder.validationError.item_note_too_long',
    type: REVIEW_ORDER_FIELDS.RECEIVER_INSTRUCTION.key,
  },
  reference_code_too_long: {
    message: 'v2.error.uploadOrder.validationError.reference_code_too_long',
    type: REVIEW_ORDER_FIELDS.RECEIVER_INSTRUCTION.key,
  },
  invalid_service_type: {
    message: 'v2.error.uploadOrder.validationError.invalid_service_type',
    type: REVIEW_ORDER_FIELDS.SERVICE_TYPE.key,
    isSkipQuoteError: true,
  },
  different_service_type: {
    message: 'v2.error.uploadOrder.validationError.different_service_type',
    type: REVIEW_ORDER_FIELDS.SERVICE_TYPE.key,
    isSkipQuoteError: true,
  },
  invalid_payment_method: {
    message: 'v2.error.uploadOrder.validationError.invalid_payment_method',
    type: REVIEW_ORDER_FIELDS.PAYMENT.key,
    isSkipQuoteError: true,
  },
  payment_method_disabled: {
    message: 'v2.error.uploadOrder.validationError.payment_method_disabled',
    type: REVIEW_ORDER_FIELDS.PAYMENT.key,
    isSkipQuoteError: true,
  },
  zero_distance: {
    message: 'v2.error.uploadOrder.validationError.zero_distance',
    type: REVIEW_ORDER_FIELDS.RECEIVER_ADDRESS.key,
    isSkipQuoteError: true,
  },
  empty_weight: {
    message: 'v2.error.uploadOrder.validationError.empty_weight',
    type: REVIEW_ORDER_FIELDS.WEIGHT.key,
  },
  invalid_weight: {
    message: 'v2.error.uploadOrder.validationError.invalid_weight',
    type: REVIEW_ORDER_FIELDS.WEIGHT.key,
  },
  too_heavy_weight: {
    message: 'v2.error.uploadOrder.validationError.too_heavy_weight',
    type: REVIEW_ORDER_FIELDS.WEIGHT.key,
  },
  empty_parcel_category: {
    message: enableUIV2()
      ? 'v2.error.uploadOrder.validationError.empty_field'
      : 'v2.error.uploadOrder.validationError.empty_parcel_category',
    type: REVIEW_ORDER_FIELDS.PARCEL_CATEGORY.key,
  },
  empty_vehicle_type: {
    message: enableUIV2()
      ? 'v2.error.uploadOrder.validationError.empty_field'
      : 'v2.error.uploadOrder.validationError.empty_vehicle_type',
    type: REVIEW_ORDER_FIELDS.VEHICLE_TYPE.key,
    isSkipQuoteError: true,
  },
  different_vehicle_type: {
    message: 'v2.error.uploadOrder.validationError.different_vehicle_type',
    type: REVIEW_ORDER_FIELDS.VEHICLE_TYPE.key,
    isSkipQuoteError: true,
  },
  cod_value_invalid: {
    message: 'v2.error.uploadOrder.validationError.cod_value_invalid',
    type: REVIEW_ORDER_FIELDS.CASH_ON_DELIVERY.key,
  },
  cod_not_required: {
    message: 'v2.error.uploadOrder.validationError.cod_not_required',
    type: REVIEW_ORDER_FIELDS.CASH_ON_DELIVERY.key,
  },
  different_payment_type: {
    message: 'v2.error.uploadOrder.validationError.different_payment_type',
    type: REVIEW_ORDER_FIELDS.PAYMENT.key,
    isSkipQuoteError: true,
  },
  empty_reference_code: {
    message: enableUIV2()
      ? 'v2.error.uploadOrder.validationError.empty_field'
      : 'v2.error.uploadOrder.validationError.empty_reference_code',
    type: REVIEW_ORDER_FIELDS.REFERENCE_CODE.key,
  },
  different_promo_code: {
    message: 'v2.error.uploadOrder.validationError.different_promo_code',
    type: REVIEW_ORDER_FIELDS.PROMO.key,
    isSkipQuoteError: true,
  },
  empty_sequence_number: {
    message: 'v2.error.uploadOrder.validationError.empty_sequence_number',
    type: REVIEW_ORDER_FIELDS.SEQUENCE_NUMBER.key,
  },
  duplicate_sequence_number: {
    message: 'v2.error.uploadOrder.validationError.duplicate_sequence_number',
    type: REVIEW_ORDER_FIELDS.SEQUENCE_NUMBER.key,
  },
  invalid_sequence_number: {
    message: 'v2.error.uploadOrder.validationError.invalid_sequence_number',
    type: REVIEW_ORDER_FIELDS.SEQUENCE_NUMBER.key,
  },
  require_partner_order_id: {
    message: 'v2.error.uploadOrder.validationError.require_partner_order_id',
    type: REVIEW_ORDER_FIELDS.PARTNER_ORDER_ID.key,
  },
  exceed_maximum_recipients: {
    message: 'v2.error.uploadOrder.validationError.exceed_maximum_recipients',
    type: REVIEW_ORDER_FIELDS.RECEIVER_ADDRESS.key,
    isSkipQuoteError: true,
  },
};
